import React from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'translations';
import { Layout } from 'app/components/base/Layout';
import { Field } from 'redux-form';
import StandardInput from 'app/components/base/StandardInput';
import ErrorMessageDropdown from 'app/components/base/ErrorMessageDropdown';

import style from './style.css';

const StandardInputWithError = (props) => {
  return (
    <ErrorMessageDropdown {...props}>
      <StandardInput {...props} />
    </ErrorMessageDropdown>
  );
};

const messages = {
  shipPlaceholder: { id: 'BOOK_TRIP.SHIP.PLACEHOLDER' }
};

/**
 * Builder to Ship name input
 * @param  {Component} ComposedComponent
 * @return {Component}
 */
const WrapperComponent = ({ className, ...props }) => {
  return (
    <Layout
      className={classnames(style.block, className)}
      direction="column"
      nowrap
    >
      <Layout className={style.fields} size="noshrink" nowrap>
        <Field
          name={props.name}
          id={props.name}
          component={StandardInputWithError}
          placeholder={<FormattedMessage {...messages.shipPlaceholder} />}
          rectangled
          {...props}
        />
      </Layout>
    </Layout>
  );
};

// TODO: move to Flow types
// WrapperComponent.propTypes = {
//   className: PropTypes.string,
//   name: PropTypes.string
// };

export default WrapperComponent;
